import { DOUBLE_X_SKU } from '@/utils/constants';

export default {
  methods: {
    isDoubleX(sku) {
      return sku === DOUBLE_X_SKU;
    },
  },
};
